import { docReady } from './utils';
import echartsLineChartInit from './charts/echarts/examples/basic-line-chart';
import echartsPieChartInit from './charts/echarts/examples/pie-chart';
import echartsBasicBarChartInit from './charts/echarts/examples/basic-bar-chart';
import echartsDoughnutChartInit from './charts/echarts/examples/doughnut-chart';
import echartsLineAreaChartInit from './charts/echarts/examples/line-area-chart';
import echartsStackedLineChartInit from './charts/echarts/examples/stacked-line-chart';
import echartsStackedAreaChartInit from './charts/echarts/examples/stacked-area-chart';
import echartsLineMarkerChartInit from './charts/echarts/examples/line-marker-chart';
import echartsAreaPiecesChartInit from './charts/echarts/examples/area-pieces-chart';
import echartsLineRaceChartInit from './charts/echarts/examples/line-race-chart';
import echartsStepLineChartInit from './charts/echarts/examples/step-line-chart';
import echartsLineGradientChartInit from './charts/echarts/examples/line-gradient-chart';
import echartsDynamicLineChartInit from './charts/echarts/examples/dynamic-line-chart';
import echartsHorizontalBarChartInit from './charts/echarts/examples/horizontal-bar-chart';
import echartsBarNegativeChartInit from './charts/echarts/examples/bar-negative-chart';
import echartsBarSeriesChartInit from './charts/echarts/examples/bar-series-chart';
import echartsWaterFallChartInit from './charts/echarts/examples/bar-waterfall-chart';
import echartsHorizontalStackedChartInit from './charts/echarts/examples/stacked-horizontal-bar-chart';
import echartsBarRaceChartInit from './charts/echarts/examples/bar-race-chart';
import echartsGradientBarChartInit from './charts/echarts/examples/gradient-bar-chart';
import echartsBarLineChartInit from './charts/echarts/examples/bar-line-mixed-chart';
import echartsBasicCandlestickChartInit from './charts/echarts/examples/basic-candlestick-chart';
import echartsCandlestickMixedChartInit from './charts/echarts/examples/candle-stick-mixed-chart';
import echartsUsaMapInit from './charts/echarts/examples/map-usa';
import echartsScatterBasicChartInit from './charts/echarts/examples/scatter-basic-chart';
import echartsBubbleChartInit from './charts/echarts/examples/bubble-chart';
import echartsScatterQuartetChartInit from './charts/echarts/examples/scatter-quartet';
import echartsScatterSingleAxisChartInit from './charts/echarts/examples/scatter-single-axis-chart';
import echartsBasicGaugeChartInit from './charts/echarts/examples/basic-gauge-chart';
import echartsGaugeProgressChartInit from './charts/echarts/examples/gauge-progress-chart';
import echartsGaugeRingChartInit from './charts/echarts/examples/gauge-ring-chart';
import echartsGaugeMultiRingChartInit from './charts/echarts/examples/gauge-multi-ring-chart';
import echartsGaugeMultiTitleChartInit from './charts/echarts/examples/gauge-multi-title-chart';
import echartsGaugeGradeChartInit from './charts/echarts/examples/gauge-grade-chart';
import echartsLineLogChartInit from './charts/echarts/examples/line-log-chart';
import echartsLineShareDatasetChartInit from './charts/echarts/examples/line-share-dataset-chart';
import echartsBarTimelineChartInit from './charts/echarts/examples/bar-timeline-chart';
import echartsDoughnutRoundedChartInit from './charts/echarts/examples/doughnut-rounded-chart';
import echartsPieLabelAlignChartInit from './charts/echarts/examples/pie-label-align-chart';
import echartsRadarChartInit from './charts/echarts/examples/radar-chart';
import echartsRadarCustomizedChartInit from './charts/echarts/examples/radar-customized-chart';
import echartsRadarMultipleChartInit from './charts/echarts/examples/radar-multiple-chart';
import echartsPieMultipleChartInit from './charts/echarts/examples/pie-multiple-chart';
import echartsHeatMapChartInit from './charts/echarts/examples/heatmap-chart';
import echartsHeatMapSingleSeriesChartInit from './charts/echarts/examples/heatmap-single-series-chart';
import echartsBarStackedChartInit from './charts/echarts/examples/bar-stacked-chart';
import echartsPieEdgeAlignChartInit from './charts/echarts/examples/pie-edge-align-chart';
import echartsStackedVerticalChartInit from './charts/echarts/examples/stacked-vertical-chart';
import echartsNestedPiesChartInit from './charts/echarts/examples/nested-pies-chart';

/* -------------------------------------------------------------------------- */
/*                            Theme Initialization                            */
/* -------------------------------------------------------------------------- */
docReady(echartsLineChartInit);
docReady(echartsLineAreaChartInit);
docReady(echartsPieChartInit);
docReady(echartsBasicBarChartInit);
docReady(echartsDoughnutChartInit);
docReady(echartsStackedLineChartInit);
docReady(echartsStackedAreaChartInit);
docReady(echartsLineMarkerChartInit);
docReady(echartsAreaPiecesChartInit);
docReady(echartsLineRaceChartInit);
docReady(echartsStepLineChartInit);
docReady(echartsLineGradientChartInit);
docReady(echartsDynamicLineChartInit);
docReady(echartsHorizontalBarChartInit);
docReady(echartsBarNegativeChartInit);
docReady(echartsBarSeriesChartInit);
docReady(echartsWaterFallChartInit);
docReady(echartsHorizontalStackedChartInit);
docReady(echartsBarRaceChartInit);
docReady(echartsGradientBarChartInit);
docReady(echartsBarLineChartInit);
docReady(echartsBasicCandlestickChartInit);
docReady(echartsCandlestickMixedChartInit);
docReady(echartsUsaMapInit);
docReady(echartsScatterBasicChartInit);
docReady(echartsBubbleChartInit);
docReady(echartsScatterQuartetChartInit);
docReady(echartsScatterSingleAxisChartInit);
docReady(echartsBasicGaugeChartInit);
docReady(echartsGaugeProgressChartInit);
docReady(echartsGaugeRingChartInit);
docReady(echartsGaugeMultiRingChartInit);
docReady(echartsGaugeMultiTitleChartInit);
docReady(echartsGaugeGradeChartInit);
docReady(echartsLineLogChartInit);
docReady(echartsLineShareDatasetChartInit);
docReady(echartsBarTimelineChartInit);
docReady(echartsDoughnutRoundedChartInit);
docReady(echartsPieLabelAlignChartInit);
docReady(echartsRadarChartInit);
docReady(echartsRadarCustomizedChartInit);
docReady(echartsRadarMultipleChartInit);
docReady(echartsPieMultipleChartInit);
docReady(echartsHeatMapChartInit);
docReady(echartsHeatMapSingleSeriesChartInit);
docReady(echartsBarStackedChartInit);
docReady(echartsPieEdgeAlignChartInit);
docReady(echartsStackedVerticalChartInit);
docReady(echartsNestedPiesChartInit);
